import { Component, input } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ButtonComponentModule } from '@src/app/components/button/button.component.module.js'
import { SharedModule } from '@src/app/shared/shared.module.js'

@Component({
  imports: [ButtonComponentModule, TranslateModule, SharedModule],
  selector: 'app-oura-registration-box',
  templateUrl: './oura-registration-box.component.html',
  styleUrls: ['./oura-registration-box.component.scss'],
})
export class OuraRegistrationBoxComponent {
  protected api = input.required<{ onOuraSelected: (ownsDevice: boolean) => Promise<void> }>()
}
